export class KgToTonnesValueConverter {
  toView(value) {
    return value ? value / 1000 : null;
  }
}
